// extracted by mini-css-extract-plugin
export var caseStudyText = "CaseStudyText-module--caseStudyText--b5572";
export var readMore = "CaseStudyText-module--readMore--3d135";